<template>
  <donut-slack-preview :hide-name="true" :message="message" />
</template>

<script setup>
  import { inject, computed } from 'vue';
  import { useStore } from 'vuex';
  import { capitalize } from 'lodash';

  const $i18n = inject('$i18n');
  const { getters } = useStore();
  const props = defineProps({
    points: { type: Number, default: 1 },
  });

  const pointsPhrase = (points) => getters['pointsConfig/pointsPhraseFromConfig']({ points });
  const message = computed(() => `${capitalize($i18n.t('shoutouts.shoutout', { count: 1 }))} sent! You sent :::@sukrit::: `
      + `and :::@jeff::: *${pointsPhrase(props.points)}* each. You have *${pointsPhrase(7)}* left this week.`);
</script>
